export default "__VITE_ASSET__C70iSK$s__"